import API from "./api";
import router from "@/router";

export default {
  fetchTrainerCount() {
    return API().get("trainers-count");
  },
  fetchTrainersExport() {
    return API().get("trainers");
  },
  fetchTrainers(currentPage, perPage) {
    return API().get("table/trainers", {
      params: {
        currentPage,
        perPage,
      },
    });
  },
  fetchClusterTrainers(id,currentPage, perPage) {
    return API().get(`table/trainers/${id}`, {
      params: {
        currentPage,
        perPage,
      },
    });
  },
  fetchCoordinatorTrainers(id) {
    return API().get(`coordinators/${id}/trainers`);
  },
  fetchTrainerNames() {
    return API().get("trainers/names");
  },
  addTrainer(user, trainer) {
    return API().post("trainers", { user, trainer });
  },
  updateTrainer(params) {
    return API().put(`trainers/${router.currentRoute.params.id}`, params);
  },
  getTrainer() {
    return API().get(`trainers/${router.currentRoute.params.id}`);
  },
  updateTrainerActive(params) {
    return API().put(`trainers/${params.uuid}`, params);
  },
  fetchTrainerGroups() {
    return API().get(`trainers/${router.currentRoute.params.id}/groups`);
  },
  fetchTrainerSchools() {
    return API().get(`trainers/${router.currentRoute.params.id}/schools`);
  },
  addTrainerSchool(params) {
    console.log(params);
    console.log(router.currentRoute.params.id);
    return API().post(
      `trainers/${router.currentRoute.params.id}/schools`,
      params
    );
  },
  updateTrainerSchool(params) {
    return API().put(
      `trainers/${router.currentRoute.params.id}/schools`,
      params
    );
  },
  deleteTrainerSchool(params) {
    return API().delete(
      `trainers/${router.currentRoute.params.id}/schools/${params.id}`
    );
  },
  fetchTrainerPrimarySchools() {
    return API().get(
      `trainers/${router.currentRoute.params.id}/primary-schools`
    );
  },
  addTrainerPrimarySchool(params) {
    console.log(params);
    console.log(router.currentRoute.params.id);
    return API().post(
      `trainers/${router.currentRoute.params.id}/primary-schools`,
      params
    );
  },
  updateTrainerPrimarySchool(params) {
    return API().put(
      `trainers/${router.currentRoute.params.id}/primary-schools/${params.id}`,
      params
    );
  },
  deleteTrainerPrimarySchool(params) {
    return API().delete(
      `trainers/${router.currentRoute.params.id}/primary-schools/${params.id}`
    );
  },
  fetchTrainerTeachers() {
    return API().get(`trainers/${router.currentRoute.params.id}/teachers`);
  },
  fetchTrainerSchoolsTeachers() {
    return API().get(
      `trainers/${router.currentRoute.params.id}/schools/teachers`
    );
  },
  addTrainerTeacher(params) {
    return API().post(
      `trainers/${router.currentRoute.params.id}/teachers`,
      params
    );
  },
  updateTrainerTeacher(params) {
    const trainerTeacherId = params.teacher_uuid;
    return API().put(
      `trainers/${router.currentRoute.params.id}/teachers/${trainerTeacherId}`,
      params
    );
  },
  deleteTrainerTeacher(params) {
    return API().delete(
      `trainers/${router.currentRoute.params.id}/teachers/${params.uuid}`
    );
  },
  fetchTrainerGroups() {
    return API().get(`trainers/${router.currentRoute.params.id}/groups`);
  },
  fetchTrainerObservations() {
    return API().get(`trainers/${router.currentRoute.params.id}/observations`);
  },
  fetchTrainerObservationsByType(type) {
    return API().get(`trainers/${router.currentRoute.params.id}/observations/type/${type}`);
  },
  addTrainerObservation(params) {
    return API().post("trainers/observations", params);
  },
  updateTrainerObservation(params) {
    return API().put(
      `trainers/${router.currentRoute.params.id}/observations/${params.id}`,
      params
    );
  },
  deleteTrainerObservation(trainerObservationId) {
    return API().delete(
      `trainers/${router.currentRoute.params.id}/observations/${trainerObservationId}`
    );
  },
  fetchTrainerCovidObservations() {
    return API().get(
      `trainers/${router.currentRoute.params.id}/covid-observations`
    );
  },
  addTrainerCovidObservation(params) {
    return API().post("trainers/covid-observations", params);
  },
  updateTrainerCovidObservation(params) {
    console.log("in service");
    return API().put(
      `trainers/${router.currentRoute.params.id}/covid-observations/${params.id}`,
      params
    );
  },
  deleteTrainerCovidObservation(trainerCovidObservationId) {
    return API().delete(
      `trainers/${router.currentRoute.params.id}/covid-observations/${trainerCovidObservationId}`
    );
  },
  fetchSchoolNamesByTrainer() {
    return API().get(`trainers/${router.currentRoute.params.id}/school-names`);
  },
  fetchTeacherNamesByTrainerSchool(id) {
    return API().get(`schools/${id}/teacher-names`);
  },
  fetchTrainerTeacherWorkshops() {
    return API().get(
      `trainers/${router.currentRoute.params.id}/teacher-workshops`
    );
  },
  fetchOneTrainerTeacherWorkshop(id) {
    return API().get(
      `trainers/${router.currentRoute.params.id}/teacher-workshops/${id}`
    );
  },
  addTrainerTeacherWorkshop(params) {
    return API().post(
      `trainers/${router.currentRoute.params.id}/teacher-workshops`,
      params
    );
  },
  updateTrainerTeacherWorkshop(params) {
    const trainerTeacherId = params.id;
    return API().put(
      `trainers/${router.currentRoute.params.id}/teacher-workshops/${trainerTeacherId}`,
      params
    );
  },
  deleteTrainerTeacherWorkshop(params) {
    return API().delete(
      `trainers/${router.currentRoute.params.id}/teacher-workshops/${params.id}`
    );
  },
  fetchTrainerModules() {
    return API().get(`trainers/${router.currentRoute.params.id}/modules`);
  },
  fetchOneTrainerModule(id) {
    return API().get(`trainers/${router.currentRoute.params.id}/modules/${id}`);
  },
  addTrainerModule(params) {
    return API().post(
      `trainers/${router.currentRoute.params.id}/modules`,
      params
    );
  },
  updateTrainerModule(params) {
    return API().put(
      `trainers/${router.currentRoute.params.id}/modules/${params.id}`,
      params
    );
  },
  deleteTrainerModule(id) {
    return API().delete(
      `trainers/${router.currentRoute.params.id}/modules/${id}`
    );
  },
  deleteTrainerGroup(params){
    return API().put(
      '/trainers/group/delete',
      params
    )
  }
};
